document.addEventListener("DOMContentLoaded", () => {
    const switcher = document.querySelector("button.current-lang");
    const dropdown = document.querySelector(".lang-dropdown");

    if (switcher && dropdown) {
        switcher.addEventListener("mouseover", () => {
            dropdown.classList.add("show");
            switcher.classList.add("open");
        });

        dropdown.addEventListener("mouseover", () => {
            dropdown.classList.add("show");
            switcher.classList.add("open");
        });

        // Закрытие dropdown при клике вне
        document.addEventListener("mouseover", (event) => {
            if (!switcher.contains(event.target) && !dropdown.contains(event.target)) {
                dropdown.classList.remove("show");
                switcher.classList.remove("open");
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const currentLangItem = document.querySelector('.lang-dropdown .current-lang');

    if (currentLangItem) {
        const newLang = currentLangItem.textContent.trim();

        const button = document.querySelector('.language-switcher > .current-lang');
        if (button) {
            button.childNodes[0].textContent = `${newLang} `;
        }

        currentLangItem.remove();
    }

    const header = document.querySelector('.header');

    if (window.innerWidth > 1400) {
        document.querySelectorAll('.menu-item-depth-0 a.main-menu-link').forEach(menuItem => {
            menuItem.addEventListener('mouseover', () => {
                const subMenu = menuItem.parentElement.querySelector('.menu-depth-1');

                if (subMenu) {
                    document.querySelectorAll('.sub-menu.menu-depth-1.active').forEach(item => {
                        item.classList.remove('active');
                    });

                    subMenu.classList.add('active');
                    header.classList.add('active');

                    const items = subMenu.querySelectorAll("li");
                    const computedStyles = window.getComputedStyle(subMenu);

                    let rowGap = parseFloat(computedStyles.gap) || parseFloat(computedStyles.gridRowGap) || 0;
                    let itemsCount = items.length;

                    if (itemsCount > 4) itemsCount = 4;

                    let itemsHeight = 0;

                    for (let i = 0; i < itemsCount; i++) {
                        itemsHeight += items[i].offsetHeight;
                    }

                    const gapHeight = rowGap * (itemsCount - 1);
                    const totalHeight = gapHeight + itemsHeight;

                    subMenu.style.setProperty("--before-height", `${totalHeight}px`);
                }
            });

            const subMenu = menuItem.parentElement.querySelector('.menu-depth-1');

            if (subMenu) {
                subMenu.addEventListener('mouseleave', () => {
                    subMenu.classList.remove('active');
                    header.classList.remove('active');

                    document.querySelectorAll('.sub-menu.menu-depth-1.active').forEach(item => {
                        item.classList.remove('active');
                    });
                });
            }
        });
    }

    const burgerMenuIcon = document.querySelector('.burger-menu-logo');
    const closeBurgerMenuBtn = document.querySelector('.close-burger-menu-btn');
    const menuItemsWrap = document.querySelector('.menu-items');
    const specialButtonBlock = document.querySelector('.specialButtonBlock');
    const mobileTools = document.querySelector('.mobile-tools');
    const mobileSearch = document.querySelector('.mobile-search');

    burgerMenuIcon.addEventListener('click', () => {
        header.classList.add('active');
        header.style.position = 'sticky';
        document.querySelector('body').classList.add('scroll-disabled');
        menuItemsWrap.classList.add('active-mobile');
        closeBurgerMenuBtn.style.display = 'block';
        burgerMenuIcon.style.display = 'none';
        mobileTools.appendChild(specialButtonBlock);
    });

    closeBurgerMenuBtn.addEventListener('click', () => {
        burgerMenuIcon.style.display = 'block';
        closeBurgerMenuBtn.style.display = 'none';
        menuItemsWrap.classList.remove('active-mobile');
        header.style.position = 'fixed';
        mobileSearch.classList.remove('active');
        setTimeout(function () {
            header.classList.remove('active');
            document.querySelector('body').classList.remove('scroll-disabled');
        }, 1000);
    });

    document.querySelectorAll(".open-submenu-icon").forEach(icon => {
        icon.addEventListener("click", function (event) {
            event.stopPropagation();
            let submenu = this.closest("li")?.querySelector("ul.sub-menu");

            if (submenu) {
                submenu.classList.toggle("submenu-open");
                icon.classList.toggle("active");
            }
        });
    });

    //Открытие подменю доступных языков на мобилке
    const mobileLnBtn = document.querySelector('.mobile-current-lang');

    if (mobileLnBtn) {
        mobileLnBtn.addEventListener("click", function (event) {
            event.stopPropagation();
            let submenu = document.querySelector(".mobile-lang-dropdown");

            if (submenu) {
                submenu.classList.toggle("submenu-open");
            }

            const submenuIcon = mobileLnBtn.querySelector('.open-submenu-icon');

            if (submenuIcon) {
                submenuIcon.classList.toggle('active');
            }
        });
    }

    document.querySelector('.mobile-current-lang .arrow svg').addEventListener('click', function (event) {
        event.stopPropagation();
        mobileLnBtn.click();
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const currentLangItem = document.querySelector(".mobile-lang-dropdown .current-lang");

    if (currentLangItem) {
        const langText = currentLangItem.textContent.trim();
        const textSpan = document.querySelector(".mobile-current-lang .text");

        if (textSpan) {
            textSpan.textContent = langText;
        }

        currentLangItem.remove();
    }
});

// Search
document.addEventListener("DOMContentLoaded", function () {
    const searchButton = document.getElementById('search-button');

    searchButton.addEventListener('click', function () {
        const searchInput = document.getElementById('search-input');

        if (searchInput) {
            searchInput.parentElement.classList.toggle('active');
        }

        const searchButton = document.getElementById('search-button');

        if (searchButton) {
            searchButton.classList.toggle('active');
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const searchInputWrappers = document.querySelectorAll(".search .wp-block-search__inside-wrapper");

    searchInputWrappers.forEach(function (element, index) {
        const clearSearchButton = "<button type='button' class='search__cancel-button'></button>";
        element.insertAdjacentHTML('beforeend', clearSearchButton);

        const input = element.querySelector('input[type="search"], input[type="text"]');
        const clearButton = element.querySelector('.search__cancel-button');
        const searchButton = element.querySelector('.wp-block-search__button[type=submit]');

        input.required = false;

        clearButton.addEventListener('click', function (e) {
            e.preventDefault();
            input.value = '';
            input.focus();
            clearButton.style.display = 'none';
            searchButton.style.display = 'none';
        });

        input.addEventListener('input', function () {
            clearButton.style.display = input.value ? 'inline' : 'none';
            searchButton.style.display = input.value ? 'inline' : 'none';
        });

        clearButton.style.display = input.value ? 'inline' : 'none';
        searchButton.style.display = input.value ? 'inline' : 'none';

        searchButton.addEventListener('click', function (e) {
            if (!input.value) {
                e.preventDefault();
            }
        });
    });
});

// Mobile search
document.addEventListener("DOMContentLoaded", function () {
    const searchWrapper = document.querySelector('.mobile-search__wrapper');

    searchWrapper.addEventListener('click', function () {
        const searchInput = document.getElementById('mobile-search-input');

        if (searchInput) {
            searchInput.parentElement.classList.toggle('active');
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const searchInputWrapper = document.querySelector(".mobile-search .wp-block-search__inside-wrapper");

    const clearSearchButton = "<button type='button' class='mobile-search__cancel-button'></button>";
    searchInputWrapper.insertAdjacentHTML('beforeend', clearSearchButton);

    const input = searchInputWrapper.querySelector('input[type="search"], input[type="text"]');
    const clearButton = searchInputWrapper.querySelector('.mobile-search__cancel-button');
    const searchButton = searchInputWrapper.querySelector('.wp-block-search__button[type=submit]');

    input.required = false;

    clearButton.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = '';
        input.focus();
        clearButton.style.display = 'none';
        searchButton.style.display = 'none';
    });

    input.addEventListener('input', function () {
        clearButton.style.display = input.value ? 'inline' : 'none';
        searchButton.style.display = input.value ? 'inline' : 'none';
    });

    clearButton.style.display = input.value ? 'inline' : 'none';
    searchButton.style.display = input.value ? 'inline' : 'none';

    searchButton.addEventListener('click', function (e) {
        if (!input.value) {
            e.preventDefault();
        }
    });
});